import { render } from "./MultiQuestion.vue?vue&type=template&id=1cf03d5a"
import script from "./MultiQuestion.vue?vue&type=script&lang=js"
export * from "./MultiQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__